import styled from "styled-components";

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px 0 15px 0;
`;

export const ExpandedContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;

    .expanded-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .section-title {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${(props: any) => props.theme.colors.c64748b};
        margin-bottom: 8px;
    }

    .anexos-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
`;

export const TableContainer = styled.div`
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    overflow: hidden;
    width: 100%;

    .data-table {
        width: 100%;
        font-size: 10px;
        border-collapse: collapse;

        thead {
            background-color: var(--table-thead-bg);

            th {
                text-align: left;
                padding: 8px;
                font-weight: 500;
                font-size: 10px;
                color: ${({ theme }) => theme.colors.c000000};
                white-space: nowrap;

                &.field-col-three {
                    width: 25%;
                }

                &.before-col {
                    width: 30%;
                }

                &.after-col {
                    width: 45%;
                }
            }
        }

        tbody {
            tr {
                border-top: 1px solid rgba(0, 0, 0, 0.1);

                &:first-child {
                    border-top: none;
                }

                td {
                    padding: 8px;
                    vertical-align: top;
                    font-size: 10px;
                    word-break: break-word;

                    &.field-cell {
                        color: ${(props: any) => props.theme.colors.c64748b};
                    }

                    &.before-cell {
                        color: ${(props: any) => props.theme.colors.c64748b};
                        white-space: pre-wrap;
                    }

                    &.after-cell {
                        color: ${({ theme }) => theme.colors.c000000};
                        white-space: pre-wrap;
                    }
                }
            }
        }
    }

    @media (max-width: 640px) {
        overflow-x: auto;

        .data-table {
            min-width: 320px;
        }
    }
`;

export const AnexoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    &[data-excluido="true"] {
        background-color: transparent;
        &:hover {
            background-color: transparent;
        }
    }
`;

export const AnexoInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const AnexoNome = styled.p`
    font-size: 10px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.c000000};
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AnexoTamanho = styled.p`
    font-size: 9px;
    color: ${(props: any) => props.theme.colors.c64748b};
    margin: 0;
    margin-top: 2px;
`;

export const AnexoLinkButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    &:active {
        background-color: rgba(0, 0, 0, 0.1);
    }

    svg {
        height: 14px;
        width: 14px;
        color: ${(props: any) => props.theme.colors.c64748b};
    }
`;

